import Model, { attr, belongsTo } from '@ember-data/model';

export default class V2TaskModel extends Model {
  @attr('string') contactId?: string;
  // used to create new task for multiple contacts
  // deprecated. still need to remove it from places it is being used
  @attr() contactIdsAndGroups?: any;
  // used to create task for multiple contacts
  @attr() contactIds?: string[];
  @attr('string') actionId?: string;
  @attr('string') resultId?: string;
  get isAttemptedResult() {
    return this.resultId === '2';
  }
  @attr('string') mediumId?: string;
  @attr('string') summary?: string;
  @attr('string') notes?: string;
  @attr('date-only') dueDate?: Date;
  @attr('date-only') completedDate?: Date;
  get isComplete() {
    return this.completedDate != null;
  }
  @attr('date') updatedAt?: Date;
  @attr('string') journalStageId?: string;
  @attr('string') taskGroupId?: string;
  // properties below are only present when :assign_tasks ability is true
  @attr('string') fundId?: string;
  // only present when task is for another fund
  @belongsTo('task-contact', { async: false, inverse: null }) contact?: any;
  @attr() assignedUserIds?: string[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'v2-task': V2TaskModel;
  }
}
